export default __webpack_public_path__ + "static/media/corporate.59eb2631.svg";